import { motion } from "framer-motion";

const STATS = [
  { big: "$30B+", label: "INDIA QSR, 2026", body: "Growing at 9.3% a year to a projected $47B by 2031." },
  { big: "1,000", label: "SUB-FORMAT STORES IN INDIA", body: "The sub format is already familiar from metro to tier-2 India." },
  { big: "40,000/day", label: "VADA PAVS, ONE BRAND", body: "A single branded vada pav chain's Mumbai peak — proof that branded vada pav scales." },
];

const FLOW = [
  { title: "STREET TAPRI", sub: "all soul, zero consistency", hot: false },
  { title: "BIG QSR", sub: "all consistency, zero soul", hot: false },
  { title: "VADA SUB", sub: "dono. that's the trick.", hot: true },
];

export const WhyNow = () => (
  <section id="whynow" data-testid="whynow-section" className="bg-pav py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <p className="font-bungee text-xs tracking-[0.35em] text-gulabi sm:text-sm">WHY NOW</p>
      <h2 className="mt-4 max-w-4xl font-shrikhand text-4xl leading-tight text-kadak sm:text-5xl lg:text-6xl">
        Street food is a giant. <span className="text-mirchi">Branded street food is a rocket.</span>
      </h2>
      <p className="mt-5 max-w-2xl text-base text-kadak/70">
        India eats vada pav every day — but almost all of it is unorganised. Customers will pay a premium
        for the same soul, served consistently and hygienically.
      </p>
      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            className="rounded-3xl border-4 border-kadak bg-taxi/20 p-7 sticker-shadow"
          >
            <p className="font-bungee text-4xl text-kadak">{s.big}</p>
            <p className="mt-2 font-bungee text-xs tracking-widest text-mirchi">{s.label}</p>
            <p className="mt-3 text-sm text-kadak/70">{s.body}</p>
          </motion.div>
        ))}
      </div>
      <div className="mt-10 flex flex-col items-stretch gap-4 md:flex-row md:items-center">
        {FLOW.map((f, i) => (
          <div key={f.title} className="flex flex-1 items-center gap-4">
            <div
              className={`flex-1 rounded-2xl border-4 p-5 ${
                f.hot ? "border-taxi bg-kadak sticker-shadow-taxi" : "border-dashed border-kadak/40 bg-pav"
              }`}
            >
              <p className={`font-anton text-lg uppercase ${f.hot ? "text-taxi" : "text-kadak"}`}>{f.title}</p>
              <p className={`text-sm ${f.hot ? "text-pav/70" : "text-kadak/60"}`}>{f.sub}</p>
            </div>
            {i < FLOW.length - 1 && <span className="hidden font-bungee text-2xl text-mirchi md:block">→</span>}
          </div>
        ))}
      </div>
    </div>
  </section>
);
